export const ticketConfig = [
  { id: 1000, name: "Status", key: "status" },
  { id: 2000, name: "Priority", key: "priority" },
  { id: 3000, name: "Category", key: "category" },
  { id: 4000, name: "Urgency", key: "urgency" }
];

export const taskLevel = [
  { id: 1, name: "Ignored", color: "1DAAE5" },
  { id: 2, name: "Backlog", color: "6BE51D" },
  { id: 3, name: "Evaluate", color: "1C5045" },
  { id: 4, name: "Review", color: "831DE5" },
  { id: 5, name: "Final result", color: "E51D64" }
];

export const priority = [
  { id: 1, name: "Very low", color: "512da8" },
  { id: 2, name: "Low", color: "54979F" },
  { id: 3, name: "Normal", color: "f50057" },
  { id: 4, name: "High", color: "00c853" },
  { id: 5, name: "Very high", color: "ff6f00" }
];

export const itemStatus = [
  { id: 1, name: "Open", color: "success", icon: "open_in_new" },
  { id: 2, name: "In Progress", color: "primary", icon: "amp_stories" },
  { id: 3, name: "Closed", color: "error", icon: "cancel" }
];

export const themeColors = [
  {
    key: "blue",
    value: {
      sideNav: "blue",
      mainNav: "blue",
      sideManu: "white"
    }
  },
  {
    key: "teal",
    value: {
      sideNav: "teal",
      mainNav: "teal",
      sideManu: "white"
    }
  },
  {
    key: "red",
    value: {
      sideNav: "red",
      mainNav: "red",
      sideManu: "white"
    }
  },
  {
    key: "orange",
    value: {
      sideNav: "orange",
      mainNav: "orange",
      sideManu: "white"
    }
  },
  {
    key: "purple",
    value: {
      sideNav: "purple",
      mainNav: "purple",
      sideManu: "white"
    }
  },
  {
    key: "indigo",
    value: {
      sideNav: "indigo",
      mainNav: "indigo",
      sideManu: "white"
    }
  },
  {
    key: "cyan",
    value: {
      sideNav: "cyan",
      mainNav: "cyan",
      sideManu: "white"
    }
  },
  {
    key: "pink",
    value: {
      sideNav: "pink",
      mainNav: "pink",
      sideManu: "white"
    }
  },
  {
    key: "green",
    value: {
      sideNav: "green",
      mainNav: "green",
      sideManu: "white"
    }
  }
];
